<div class="aside-footer-container">
  <div class="aside-left-section" id="bar-right">
    @if (casesheet_data) {
      <div class="aside-tabs-container">
        @for (case of casesheet_data.casesheet  ; track case; let i = $index) {
          <div class="aside-tab-button" [ngClass]="casesheet_data.current == (case.resource ? case.resource : case.template) ? 'active': ''" (click)="tabClicked(case)">
            <img class="aside-tab-btn-icon" src={{case.icon}}>
            <span class="aside-tab-btn-name" id=case-{{i}}>{{case.display_name}}
              @if (case['isRequired']) {
                <span class="required">*</span>
              }
            </span>
          </div>
        }
      </div>
    }
  </div>
  <div class="aside-right-section">
    <div class="aside-tab-actions">
      @if (commonService.expandButton && !utilService.isMobile()) {
        <button class="primary-btn" (click)="setExpandClasses()">
          <i aria-hidden="true" class="fa fa-chevron-up"></i>
        </button>
      }
      @if (!commonService.expandButton && !utilService.isMobile()) {
        <button class="primary-btn" (click)="setCollapseClasses()">
          <i aria-hidden="true" class="fa fa-chevron-down"></i>
        </button>
      }
      @if (commonService.expandButton && utilService.isMobile()) {
        <button class="primary-btn" (click)="showExpandedTab()">
          <i aria-hidden="true" class="fa fa-chevron-up"></i>
        </button>
      }

      <button class="primary-btn" style="display:none;">
        <i aria-hidden="true" class="fa fa-cog"></i>
      </button>
    </div>
  </div>


</div>
@if (casesheet_data && currentConfig.expanded) {
  <div class="aside-mobile-container">
    @if (utilService.isMobile()) {
      <button class="primary-btn" (click)="showCollapsedTab()" style="float: right;">
        <i aria-hidden="true" class="fa fa-chevron-down"></i>
      </button>
    }
    @for (case of casesheet_data.casesheet  ; track case; let i = $index) {
      <div class="aside-mobile-button" [ngClass]="casesheet_data.current == (case.resource ? case.resource : case.template) ? 'active': ''" (click)="tabClicked(case)">
        <img class="aside-tab-btn-icon" src={{case.icon}}>
        <span class="aside-tab-btn-name" id=case-{{i}}>{{case.display_name}}
          @if (case['isRequired']) {
            <span class="required">*</span>
          }
        </span>
      </div>
    }
  </div>
}
